var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScientificWork24 = function SvgScientificWork24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.002 12a1 1 0 0 0-.833 1.555l1.329 1.992A3 3 0 0 1 19 17.211v1.52a3 3 0 0 1-.549 1.73l-4.141 5.867A3.598 3.598 0 0 0 17.25 32h9.086a3.814 3.814 0 0 0 3.116-6.013l-3.901-5.526a3 3 0 0 1-.55-1.73v-1.52a3 3 0 0 1 .504-1.664l1.329-1.992A1 1 0 0 0 26.002 12h-8Zm2.16 2.438L19.87 14h4.263l-.292.438a5 5 0 0 0-.84 2.773v1.52a5 5 0 0 0 .916 2.883l1.766 2.502-9.87 3.59c.037-.078.081-.153.132-.225l4.141-5.867a5 5 0 0 0 .916-2.884v-1.519a5 5 0 0 0-.84-2.773Z",
    fill: "currentColor"
  })));
};
export default SvgScientificWork24;